<div
  mat-dialog-title
  appDraggableDialog
  draggableKey="header-renumber"
  dialogClass=".q9-drag-anchor">
  <span>{{ 'POPUPS.RENUMBER_TITLE' | translate }}</span>
  <q9-dialog-close-button></q9-dialog-close-button>
</div>

<mat-dialog-content class="reorder">
  <div class="reorder--hint q9-hint">{{ 'POPUPS.RENUMBER_HINT' | translate }}</div>
  <ng-container>
    <div #dragContainer [dragula]="bagPrefix" [dragulaModel]="list">
      <div
        class="reorder--item"
        *ngFor="let activity of list; index as $i"
        (mouseenter)="highlight(activity.mxKey, true)"
        (mouseleave)="highlight(activity.mxKey, false)"
        [attr.data-mxKey]="activity.mxKey"
        [attr.data-index]="$i">
        <span class="reorder--item__text">
          {{ activity.index + 1 }}. {{ activity.text | decodeHtml | cleanupHtml }}
        </span>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
